import {IntegerField} from "@khanacademy/event-schemas";
import type {
    ContentLibraryUserInterfaceFields,
    CurrentPageContentPathFields,
} from "@repo/analytics-learning-time";
import {pureSmMax} from "@repo/shared-styles";

import useContentPath from "../data-access/use-content-path.ts";

import {getCurrentPageContentPathFields} from "./utils/get-content-path-fields.ts";

type EventFields = CurrentPageContentPathFields &
    ContentLibraryUserInterfaceFields;

// Hook returning the fields which are common to Content Library CEDAR events.
export const useCommonContentLibraryAnalyticsFields = (): EventFields => {
    const {contentPath} = useContentPath();

    return {
        ...getCurrentPageContentPathFields(contentPath),
        ...getUserInterfaceAnalyticsFields(),
    };
};

/**
 * A function returning the contentLibraryUserInterface_* fields for analytics.
 */
export const getUserInterfaceAnalyticsFields =
    (): ContentLibraryUserInterfaceFields => {
        const innerWidth = window.innerWidth;
        return {
            contentLibraryUserInterface_interfaceVariant:
                innerWidth <= parseInt(pureSmMax)
                    ? ("mobile" as const)
                    : ("desktop" as const),
            contentLibraryUserInterface_screenHeight: new IntegerField(
                window.innerHeight,
            ),
            contentLibraryUserInterface_screenWidth: new IntegerField(
                innerWidth,
            ),
        };
    };
